export default __webpack_public_path__ + "static/media/kardinal-preview.c1c84644.png";